var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "7px",
    viewBox: "0 0 10 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "542696B7-5567-4D12-90DA-DCAD3B4FF147") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Questionnaire",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Q-P1-US-ZIP-tooltip",
    transform: "translate(-596.000000, -517.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(589.000000, 270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reside",
    transform: "translate(0.000000, 186.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "icon-checkmark-copy",
    points: "8.91519908 63.1197411 10.8489025 64.9029126 15.0848009 61 16.5833333 62.381877 12.3509444 66.2847896 10.8489025 67.6666667 9.35037009 66.2847896 7.41666667 64.5016181"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmark);
export default __webpack_public_path__ + "static/media/icon-checkmark.031f3beb832473238f441198ea681830.svg";
export { ForwardRef as ReactComponent };